import {Component} from '@angular/core';

@Component({
  template: '<h1>Not found</h1>',
  standalone: true
})
export class NotFoundComponent {
}
